import PlainLabel from 'app/common/ui-next/plain-label'
import { useDataBoxSelector } from 'app/common/data-box-store'
import { orgsFilterSelection } from 'app/dataProviders/filter-items'
import styles from './OrgsFilterInfo.scss'

export const OrgsFilterInfo = () => {
  const orgsSelection = useDataBoxSelector(orgsFilterSelection, () => orgsFilterSelection.data)
  return (
    !orgsSelection.length && (
      <PlainLabel htmlFor="ors" skipBottomSpace className={styles.info}>
        Необходимо выбрать заведение
      </PlainLabel>
    )
  )
}
